import React from 'react';
import { TextField, Box, Typography, InputAdornment, Link } from '@mui/material';

interface InputFieldProps {
  name?: string;
  label: string;
  value: string | null;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  editLinkText?: string;
  onEditClick?: () => void;
}

const InputField: React.FunctionComponent<InputFieldProps> = ({ label, value, onChange, editLinkText, onEditClick, name }) => {
  console.log('editLinkText', editLinkText);

  return (
    <Box>
      <Typography
        variant="subtitle1"
        textAlign="start"
        sx={{
          fontWeight: '500',
          fontSize: '12px',
          color: '#373A45',
          '@media (min-width: 1280px) and (max-width: 1300px)': {
            fontSize: '11px !important',
          },
        }}
      >
        {label}
      </Typography>
      <TextField
        fullWidth
        variant="outlined"
        value={value}
        name={name}
        onChange={onChange}
        margin="normal"
        InputProps={{
          readOnly: true,
          style: { cursor: 'none' },
          endAdornment: editLinkText && (
            <InputAdornment position="end">
              <Link
                component="button"
                variant="body2"
                onClick={onEditClick}
                underline="none"
                style={{ cursor: 'pointer', paddingLeft: 8, color: '#3061FF', fontWeight: '500', fontSize: '14px', textDecoration: 'underline' }}
              >
                {editLinkText}
              </Link>
            </InputAdornment>
          ),
          sx: {
            background: '#fff',
            height: '36px',
            cursor: 'none !important',
            '& .MuiInputBase-input': {
              fontSize: '12px',
              fontWeight: 400,
            },
          },
        }}
        sx={{ margin: '10px 0px', background: '#fff' }}
      />
    </Box>
  );
};

export default InputField;
